// Implemented to provide payload object for manageUser api
import { VehicleData, PickupLocationData, KeysData } from "./appConstants";
export const manageUserPayload = (dealerNumber, firstName, lastName, sourceSystem, systemOperation, tenantId, userType, userEmail, userId, userRole, userStatus) => {
    let returnObj;
    returnObj = {
        dealerNumber, firstName, lastName, sourceSystem, systemOperation, tenantId, userType, userEmail, userId, userRole, userStatus
    }
    return returnObj;
}

export const getElementPayload = (payload) => {
    let Vehicle = {};
    let PickupLocation = {};
    let Keys = {};
    let reqObj = {};
    Object.entries((payload)).forEach(([key, value]) => {
        if(VehicleData.includes(key)) {
            return Vehicle[key] = value
        } else if(PickupLocationData.includes(key)) {
            return PickupLocation[key] = value
        } else if(KeysData.includes(key)) {
            if(value) {
                return Keys[key] = value
            }
        } else if(key?.indexOf('end') < 0){
            if(key?.indexOf('ReturnDate') >= 0) {
                let returnTime = value;
                if(value.indexOf(' ') < 0 && value.indexOf('/') >= 0) returnTime = `${returnTime} 00:00:00 AM`;  // only date no time
                if(value.indexOf(' ') < 0 && value.indexOf('/') < 0) returnTime = returnTime * 1000; //epoach time convert
                console.log('value', value, returnTime)
                return reqObj[key] = timeConvertor(new Date(returnTime));
            } else {
                return reqObj[key] = value;
            }
        }
      });
      reqObj.Vehicle = Vehicle;
      reqObj.PickupLocation = PickupLocation;
      reqObj.Keys = [Keys];
      return reqObj;
}

export const timeConvertor = (value) => {
    return value?.toISOString();
}

export const hourConverter = value => {
    const currentDate = new Date();
    const month = currentDate?.toLocaleString('default', { month: 'long' });
    const currentTimeValue = `${currentDate?.getDate()} ${month} ${currentDate?.getFullYear()} ${value}`;
    return timeConvertor(new Date(currentTimeValue))
}

export const HHMMSSTimeConverter = (value, startTime) => {
    const currentTime = new Date(value);
    return `${currentTime?.getHours() <= 9 ? `0${currentTime?.getHours()}`: currentTime?.getHours()}:${currentTime?.getMinutes().toString().length < 2 ? `0${currentTime?.getMinutes()}` :
     currentTime?.getMinutes()}:00`
}

export const convertBase64ToArray = (base64) => {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
       var ascii = binaryString.charCodeAt(i);
       bytes[i] = ascii;
    }
    return bytes;
 }

 export const convertToArray = (base64) => {
    var binaryLen = base64?.length || 0;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
       var ascii = base64.charCodeAt(i);
       bytes[i] = ascii;
    }
    return bytes;
 }

export const generateFileUrl = (byte,type) => {
    var blob = new Blob([byte], {type: type});
    return window.URL.createObjectURL(blob);
};

export function downloadCsvFile(content, filename, contentType) {
    var blob = new Blob([content], { type: contentType });
    var url = URL.createObjectURL(blob);
    var pom = document.createElement('a');
    pom.href = url;
    pom.setAttribute('download', filename);
    pom.click();
  }